import React from "react";

export default function ContactUs() {
  return (
    <div className="w-full h-screen overflow-y-scroll">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-8 pb-20">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Contact Us
          </h1>
          <p className="text-gray-500 mb-8">
            <b>Last updated on: December 2025</b>
          </p>
          <p className="text-lg text-gray-700 mb-8">
            We'd love to hear from you! Whether you're a fashion brand, D2C brand,
            or individual looking to use our AI-powered fashion services, have
            questions about our virtual try-on, model generation, cataloging, or
            other services, or are interested in partnerships and collaborations,
            feel free to reach out to us.
          </p>

          <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6 mb-6">
            <p className="text-gray-700 leading-relaxed">
              <strong className="text-gray-900">TryOn AI</strong> and{" "}
              <strong className="text-gray-900">TryOn Labs</strong> are brands
              owned and operated by{" "}
              <strong className="text-gray-900">
                LEVIT8 LABS PRIVATE LIMITED
              </strong>{" "}
              (a private limited company). For any inquiries, support, or
              business-related matters, please use the contact information below.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Contact Information
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    General Inquiries
                  </h3>
                  <p className="text-gray-900">
                    <a
                      href="mailto:contact@tryonlabs.ai"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      contact@tryonlabs.ai
                    </a>
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    Business & Partnerships
                  </h3>
                  <p className="text-gray-900">
                    <a
                      href="mailto:contact@tryonlabs.ai"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      contact@tryonlabs.ai
                    </a>
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    Support & Technical Issues
                  </h3>
                  <p className="text-gray-900">
                    <a
                      href="mailto:contact@tryonlabs.ai"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      contact@tryonlabs.ai
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Company Information
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    Legal Entity Name
                  </h3>
                  <p className="text-gray-900">LEVIT8 LABS PRIVATE LIMITED</p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    Brands
                  </h3>
                  <p className="text-gray-900">
                    TryOn AI
                    <br />
                    TryOn Labs
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-600 mb-1 text-sm">
                    Location
                  </h3>
                  <p className="text-gray-900">
                    Karnataka, India
                    <br />
                    <span className="text-sm text-gray-500">
                      (Fashion AI Platform)
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Registered Address
              </h3>
              <address className="text-gray-700 not-italic leading-relaxed text-sm">
                LEVIT8 LABS PRIVATE LIMITED
                <br />
                Aspire Coworks - Balaji Arcade
                <br />
                No. 472/7, Balaji Arcade, AVS Compound,
                <br />
                20th L Cross Road, AVS Layout, Ejipura,
                <br />
                Koramangala, Bengaluru, Karnataka
                <br />
                PIN: 560095
                <br />
                India
              </address>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Operational Address
              </h3>
              <address className="text-gray-700 not-italic leading-relaxed text-sm">
                LEVIT8 LABS PRIVATE LIMITED
                <br />
                Aspire Coworks - Balaji Arcade
                <br />
                No. 472/7, Balaji Arcade, AVS Compound,
                <br />
                20th L Cross Road, AVS Layout, Ejipura,
                <br />
                Koramangala, Bengaluru, Karnataka
                <br />
                PIN: 560095
                <br />
                India
              </address>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
